/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../common";
import type { VaultSwap, VaultSwapInterface } from "../VaultSwap";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_swapVaultNFT",
        type: "address",
      },
      {
        internalType: "address",
        name: "_vaultAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_creator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "time",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_swapId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "_swapCounterPart",
        type: "address",
      },
    ],
    name: "EditCounterPartEvent",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_payer",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_value",
        type: "uint256",
      },
    ],
    name: "PaymentReceived",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_creator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "time",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "enum VaultSwap.SwapStatus",
        name: "_status",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_swapId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "_swapCounterPart",
        type: "address",
      },
    ],
    name: "SwapEvent",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_dapp",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "_status",
        type: "bool",
      },
    ],
    name: "WhiteListChange",
    type: "event",
  },
  {
    inputs: [],
    name: "_whiteListMerkleRoot",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_swapCreator",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_swapId",
        type: "uint256",
      },
    ],
    name: "cancelSwapIntent",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_swapCreator",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_swapId",
        type: "uint256",
      },
      {
        internalType: "bytes32[][]",
        name: "merkleProofOne",
        type: "bytes32[][]",
      },
      {
        internalType: "bytes32[][]",
        name: "merkleProofTwo",
        type: "bytes32[][]",
      },
    ],
    name: "closeSwapIntent",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "address payable",
            name: "addressOne",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "valueOne",
            type: "uint256",
          },
          {
            internalType: "address payable",
            name: "addressTwo",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "valueTwo",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "swapStart",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "swapEnd",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "swapFee",
            type: "uint256",
          },
          {
            internalType: "enum VaultSwap.SwapStatus",
            name: "status",
            type: "uint8",
          },
        ],
        internalType: "struct VaultSwap.SwapIntent",
        name: "_swapIntent",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "address",
            name: "dapp",
            type: "address",
          },
          {
            internalType: "enum VaultSwap.AssetType",
            name: "typeStd",
            type: "uint8",
          },
          {
            internalType: "uint256[]",
            name: "tokenId",
            type: "uint256[]",
          },
          {
            internalType: "uint256[]",
            name: "blc",
            type: "uint256[]",
          },
          {
            internalType: "bytes",
            name: "data",
            type: "bytes",
          },
        ],
        internalType: "struct VaultSwap.SwapStruct[]",
        name: "_nftsOne",
        type: "tuple[]",
      },
      {
        components: [
          {
            internalType: "address",
            name: "dapp",
            type: "address",
          },
          {
            internalType: "enum VaultSwap.AssetType",
            name: "typeStd",
            type: "uint8",
          },
          {
            internalType: "uint256[]",
            name: "tokenId",
            type: "uint256[]",
          },
          {
            internalType: "uint256[]",
            name: "blc",
            type: "uint256[]",
          },
          {
            internalType: "bytes",
            name: "data",
            type: "bytes",
          },
        ],
        internalType: "struct VaultSwap.SwapStruct[]",
        name: "_nftsTwo",
        type: "tuple[]",
      },
      {
        internalType: "bytes32[][]",
        name: "merkleProofOne",
        type: "bytes32[][]",
      },
      {
        internalType: "bytes32[][]",
        name: "merkleProofTwo",
        type: "bytes32[][]",
      },
    ],
    name: "createSwapIntent",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "dappRelations",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_swapId",
        type: "uint256",
      },
      {
        internalType: "address payable",
        name: "_counterPart",
        type: "address",
      },
    ],
    name: "editCounterPart",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_creator",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_swapId",
        type: "uint256",
      },
    ],
    name: "getSwapIntentByAddress",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "address payable",
            name: "addressOne",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "valueOne",
            type: "uint256",
          },
          {
            internalType: "address payable",
            name: "addressTwo",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "valueTwo",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "swapStart",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "swapEnd",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "swapFee",
            type: "uint256",
          },
          {
            internalType: "enum VaultSwap.SwapStatus",
            name: "status",
            type: "uint8",
          },
        ],
        internalType: "struct VaultSwap.SwapIntent",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_creator",
        type: "address",
      },
    ],
    name: "getSwapListByAddress",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "address payable",
            name: "addressOne",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "valueOne",
            type: "uint256",
          },
          {
            internalType: "address payable",
            name: "addressTwo",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "valueTwo",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "swapStart",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "swapEnd",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "swapFee",
            type: "uint256",
          },
          {
            internalType: "enum VaultSwap.SwapStatus",
            name: "status",
            type: "uint8",
          },
        ],
        internalType: "struct VaultSwap.SwapIntent[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_swapId",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "_nfts",
        type: "bool",
      },
      {
        internalType: "uint256",
        name: "_index",
        type: "uint256",
      },
    ],
    name: "getSwapStruct",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "dapp",
            type: "address",
          },
          {
            internalType: "enum VaultSwap.AssetType",
            name: "typeStd",
            type: "uint8",
          },
          {
            internalType: "uint256[]",
            name: "tokenId",
            type: "uint256[]",
          },
          {
            internalType: "uint256[]",
            name: "blc",
            type: "uint256[]",
          },
          {
            internalType: "bytes",
            name: "data",
            type: "bytes",
          },
        ],
        internalType: "struct VaultSwap.SwapStruct",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_swapId",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "_nfts",
        type: "bool",
      },
    ],
    name: "getSwapStructSize",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_swapId",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "_nfts",
        type: "bool",
      },
    ],
    name: "getSwapStructs",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "dapp",
            type: "address",
          },
          {
            internalType: "enum VaultSwap.AssetType",
            name: "typeStd",
            type: "uint8",
          },
          {
            internalType: "uint256[]",
            name: "tokenId",
            type: "uint256[]",
          },
          {
            internalType: "uint256[]",
            name: "blc",
            type: "uint256[]",
          },
          {
            internalType: "bytes",
            name: "data",
            type: "bytes",
          },
        ],
        internalType: "struct VaultSwap.SwapStruct[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getWeiPayValueAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "nftsOne",
    outputs: [
      {
        internalType: "address",
        name: "dapp",
        type: "address",
      },
      {
        internalType: "enum VaultSwap.AssetType",
        name: "typeStd",
        type: "uint8",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "nftsTwo",
    outputs: [
      {
        internalType: "address",
        name: "dapp",
        type: "address",
      },
      {
        internalType: "enum VaultSwap.AssetType",
        name: "typeStd",
        type: "uint8",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "id",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "value",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "onERC1155BatchReceived",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "onERC1155Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "onERC721Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "payment",
    outputs: [
      {
        internalType: "bool",
        name: "status",
        type: "bool",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_dapp",
        type: "address",
      },
      {
        internalType: "address",
        name: "_customInterface",
        type: "address",
      },
    ],
    name: "setDappRelation",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "_status",
        type: "bool",
      },
      {
        internalType: "uint256",
        name: "_value",
        type: "uint256",
      },
    ],
    name: "setPayment",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_swapVaultNFT",
        type: "address",
      },
    ],
    name: "setSwapNftAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address payable",
        name: "_vaultAddress",
        type: "address",
      },
    ],
    name: "setVaultAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "merkleRootTreeHash",
        type: "bytes32",
      },
    ],
    name: "setWhitelist",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceID",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "swapList",
    outputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "address payable",
        name: "addressOne",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "valueOne",
        type: "uint256",
      },
      {
        internalType: "address payable",
        name: "addressTwo",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "valueTwo",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "swapStart",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "swapEnd",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "swapFee",
        type: "uint256",
      },
      {
        internalType: "enum VaultSwap.SwapStatus",
        name: "status",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "swapMatch",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "swapVaultNFT",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "toggleWhitelistEnabled",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "vaultAddress",
    outputs: [
      {
        internalType: "address payable",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "whiteListEnabled",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "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";

type VaultSwapConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: VaultSwapConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class VaultSwap__factory extends ContractFactory {
  constructor(...args: VaultSwapConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    _swapVaultNFT: PromiseOrValue<string>,
    _vaultAddress: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<VaultSwap> {
    return super.deploy(
      _swapVaultNFT,
      _vaultAddress,
      overrides || {}
    ) as Promise<VaultSwap>;
  }
  override getDeployTransaction(
    _swapVaultNFT: PromiseOrValue<string>,
    _vaultAddress: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _swapVaultNFT,
      _vaultAddress,
      overrides || {}
    );
  }
  override attach(address: string): VaultSwap {
    return super.attach(address) as VaultSwap;
  }
  override connect(signer: Signer): VaultSwap__factory {
    return super.connect(signer) as VaultSwap__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): VaultSwapInterface {
    return new utils.Interface(_abi) as VaultSwapInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): VaultSwap {
    return new Contract(address, _abi, signerOrProvider) as VaultSwap;
  }
}
